<template>
    <div
        :id="item.id"
        :aria-labelledby="`${item.id}-tab`"
        role="tabpanel"
        class="tab-pane fade"
    >
        <section class="fdep-panel">
            <FormTabHeader icon="fal fa-code-branch" :title="item.name">
                <template #actions>
                    <a
                        :href="`/forms/${form.id}/app/create`"
                        class="fdep-create-btn"
                    >
                        <i class="fal fa-plus"></i>
                        <span>Créer un déploiement</span>
                    </a>
                </template>
            </FormTabHeader>
            <div class="fdep-body">
                <TabApplication :form="form" />
            </div>
        </section>
    </div>
</template>

<script>
import FormMixin from './FormMixin'
import TabApplication from '../../Application/TabApplication'
import FormTabHeader from './FormTabHeader'

export default {
    name: 'FormDeployments',
    mixins: [FormMixin],
    components: { TabApplication, FormTabHeader },
    props: ['item']
}
</script>

<style scoped>
.fdep-panel {
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    overflow: hidden;
    margin-top: var(--v2-space-5);
}

.fdep-body {
    padding: var(--v2-space-5);
}

.fdep-create-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    padding: 0 12px;
    border: 1px solid var(--v2-primary);
    border-radius: var(--v2-radius-sm);
    background: var(--v2-primary);
    color: var(--v2-primary-contrast, #fff) !important;
    font-size: 0.82rem;
    font-weight: var(--v2-font-weight-medium);
    line-height: 1.2;
    white-space: nowrap;
    text-decoration: none !important;
    box-sizing: border-box;
    transition: background var(--v2-transition-fast), border-color var(--v2-transition-fast);
}

.fdep-create-btn:hover {
    background: var(--v2-primary-hover);
    border-color: var(--v2-primary-hover);
    color: var(--v2-primary-contrast, #fff) !important;
    text-decoration: none !important;
}

.fdep-create-btn i {
    color: inherit !important;
    font-size: 0.78rem;
}
</style>
